import React, { createContext, useContext, useMemo } from 'react'
import { useAuth } from './user';
import { GetMasterResponses } from 'hooks';

const ResponsesContext = createContext();

export const ResponseProvider = ({ children }) => {
    const { isAuthenticated } = useAuth()
    const { data: { GroupedResponse, MultipleResponse, SingleResponses } } = GetMasterResponses(isAuthenticated)

    const contextData = useMemo(() => ({
        GroupedResponse, MultipleResponse, SingleResponses,
    }), [GroupedResponse, MultipleResponse, SingleResponses])

    return (
        <ResponsesContext.Provider value={contextData}>
            {children}
        </ResponsesContext.Provider>
    )
}

export const useResponses = () => useContext(ResponsesContext)